export const SET_ALL_PRODUCTS = 'SET_ALL_PRODUCTS'
export const ADD_TO_CART = 'ADD_TO_CART'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
export const ADJUST_QUANTITY = 'ADJUST_QUANTITY'
export const SHOW_ITEM_DETAILS = 'SHOW_ITEM_DETAILS'